import React from "react";
import Markdown from "./Markdown";
import "./ClarificationBlock.css";

function ClarificationBlock({ message, suggestions, onSend }) {
  return (
    <div className="clarification-block">
      {message && <div className="clarification-message"><Markdown text={message} /></div>}
      {suggestions && suggestions.length > 0 && (
        <div className="suggestion-chips">
          {suggestions.map((s, i) => (
            <button
              key={i}
              className="suggestion-chip"
              onClick={() => onSend && onSend(s)}
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ClarificationBlock;
